
(function () {
  var root = document.querySelector('[data-nzs-pdpx]');
  if (!root || root.__nzsInit) return; root.__nzsInit = true;
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function human(s){ if(!s) return ''; return s.replace(/-/g,' ').replace(/\bnew\b/gi,'').replace(/\s+/g,' ').trim().replace(/\b\w/g,function(c){return c.toUpperCase();}); }
  function vis(sel){ var els=[].slice.call(document.querySelectorAll(sel)); for(var i=0;i<els.length;i++){ var e=els[i]; if(e.offsetParent!==null && e.getBoundingClientRect().width>0) return e; } return els[0]||null; }
  function imgEl(){ return vis('.featured-image img.image-detail') || vis('.featured-image img') || vis('.splide__slide img') || vis('.product__media img'); }
  function priceEl(){ var els=[].slice.call(document.querySelectorAll('p.price')); for(var i=0;i<els.length;i++){ var e=els[i]; if(e.offsetParent!==null && !e.closest('.x-atc-text,[id^="x-atc-button-"],.x-block-buy-buttons,.sticky_add_to_cart')) return e; } return null; }
  /* anchor for relocating per-serve + flavour: the TOP price block near the title, never the price
     inside the ATC button (the only <p class="price"> lives inside that button, so priceEl() alone
     would drop per-serve/flavour into the Add-to-cart button). Falls back to priceEl() if absent. */
  function anchorEl(){ var els=[].slice.call(document.querySelectorAll('.main-product-price.price')); for(var i=0;i<els.length;i++){ var e=els[i]; if(e.offsetParent!==null && e.getBoundingClientRect().width>0 && !e.classList.contains('inline-block') && !e.closest('.x-atc-text,[id^="x-atc-button-"],.x-block-buy-buttons')) return e; } return priceEl(); }
  /* NZS-SATC-SENTINEL 2026-08-01: also exclude the quick-view modal button. It is FIRST in the raw HTML, and at DOMContentLoaded the real buy box is still x-cloak'd, so vis() fell back to els[0] and the sticky-ATC sentinel became a zero-height section at the very bottom of the document -- making the show-window empty. */
  function atcEl(){ return vis('[id^="x-atc-button-"]:not([id*="sticky"]):not([id*="quick-view"])'); }
  function mainProductForm(){ var b=atcEl(), s=b&&b.closest('.shopify-section'); return (s&&s.querySelector('form[data-type="add-to-cart-form"]'))||document.querySelector('form[data-type="add-to-cart-form"]'); }
  function purchaseState(variantId){
    var form=mainProductForm();
    var idInput=form&&form.querySelector('input[name="id"]');
    var formId=parseInt((idInput&&idInput.value)||'0',10);
    var id=parseInt(variantId||formId||'0',10);
    var qtyInput=form&&form.querySelector('input[name="quantity"]');
    var quantity=parseInt(qtyInput&&qtyInput.value,10); if(!quantity||quantity<1) quantity=1;
    var item={id:id,quantity:quantity};
    var sp=form&&form.querySelector('input[name="selling_plan"]'); if(id===formId&&sp&&sp.value) item.selling_plan=sp.value;
    return id?item:null;
  }
  function activeHandle(){ return (current&&current.h)||root.getAttribute('data-current-handle')||''; }
  function cartError(d){ var m=d&&(d.description||d.message||d.errors); if(m&&typeof m==='object') m=Object.keys(m).map(function(k){return [].concat(m[k]).join(', ');}).join(', '); return m||"Couldn't add to cart"; }
  function cartJson(r){ return r.json().catch(function(){return {};}).then(function(d){ if(!r.ok) throw new Error(cartError(d)); return d; }); }
  var cartStatus=root.querySelector('[data-nzs-cart-status]'); if(cartStatus) document.body.appendChild(cartStatus);
  function announceCartError(message){ message=message||"Couldn't add to cart"; if(cartStatus) cartStatus.textContent='Could not add to cart. '+message; }
  root.__nzsCartJson=cartJson; root.__nzsAnnounceCartError=announceCartError;

  var data = []; try { data = JSON.parse(root.querySelector('[data-nzs-vsw-data]').textContent); } catch (e) {}
  var vsw = root.querySelector('[data-nzs-vsw]');
  var current = data.filter(function(d){return d.c;})[0] || null;
  var sel = current ? {v:current.v,a:current.a,t:current.t,img:current.img} : null;

  function relocate(){
    var price = anchorEl(); var atc = atcEl();
    var buyWrap = atc ? (atc.closest('.x-block-buy-buttons') || atc.parentNode) : null;
    var gift = root.querySelector('[data-nzs-giftbadge]');
    var giftTitleWrap = vis('.x-block-product-title');
    if (gift && giftTitleWrap && giftTitleWrap.parentNode){ giftTitleWrap.parentNode.insertBefore(gift, giftTitleWrap); gift.hidden = false; }
    var ps = root.querySelector('[data-nzs-perserve]');
    /* append INSIDE the top price block so per-serve then flavour stack under the price, near the title */
    if (ps && price){ price.appendChild(ps); }
    /* WS12: Afterpay line. ponytail: appended right here rather than computing an insertBefore
       reference — ps was appended one line above, so a plain appendChild already lands it directly
       under the per-serve line (and directly under the price when per-serve is off), and vsw is
       appended after us on the next line. Same guards + same move-on-every-call idempotency as
       its siblings: appendChild MOVES the node, so the repeat relocate() passes just re-assert
       the order rather than duplicating anything. */
    var ap = root.querySelector('[data-nzs-afterpay]');
    if (ap && price){ price.appendChild(ap); }
    if (vsw && price){ price.appendChild(vsw); }
    var sc = root.querySelector('[data-nzs-savechip]');
    if (sc && price){ var sale = price.querySelector('.price-sale'); if (sale && sale.parentNode){ sale.parentNode.insertBefore(sc, sale.nextSibling); } else { price.appendChild(sc); } }
    var subs = root.querySelector('[data-nzs-subs]');
    if (subs && buyWrap && buyWrap.parentNode){ buyWrap.parentNode.insertBefore(subs, buyWrap); }
    var hero = root.querySelector('[data-nzs-hero]'); /* NZS-PDP-HERO-0901 */
    if (hero){ var tb = document.querySelector('.main-product .x-block-product-title') || vis('.x-block-product-title'); if (tb && tb.parentNode){ tb.parentNode.insertBefore(hero, tb.nextSibling); } }
    var trust = root.querySelector('[data-nzs-trust]');
    if (trust){
      if (buyWrap && buyWrap.parentNode){ buyWrap.parentNode.insertBefore(trust, buyWrap.nextSibling); }
      else if (price && price.parentNode){ price.parentNode.appendChild(trust); }
    }
    var offers = root.querySelector('[data-nzs-offers]');
    if (offers){ var aft = trust || buyWrap; if (aft && aft.parentNode){ aft.parentNode.insertBefore(offers, aft.nextSibling); } }
    var rtd = root.querySelector('[data-nzs-rtd-offer]');
    if (rtd && buyWrap && buyWrap.parentNode){ buyWrap.parentNode.insertBefore(rtd, buyWrap.nextSibling); }
    var vc = root.querySelector('[data-nzs-viewcart]');
    if (vc && buyWrap && buyWrap.parentNode){ buyWrap.parentNode.insertBefore(vc, buyWrap.nextSibling); }
    var osz = document.querySelector('.nzs-sib-wrap');
    if (osz && vsw && vsw.parentNode){ vsw.parentNode.insertBefore(osz, vsw.nextSibling); osz.classList.add('nzs-sib--inbox'); }
    try{ hoistOverlays(); }catch(e){}
  }

  /* NZS-OV-HOIST-0820: the theme renders the star rating + sale badge only on gallery slide 1, so they
     vanish on images 2+. Move ONE of each up to the always-visible media frame as absolute overlays so
     they persist across every image. Idempotent (parent check) + skips quick-view/modal copies. */
  function hoistOverlays(){
    var frame = document.querySelector('.main-product .product-media-container') || document.querySelector('.product-media-container');
    if(!frame) return;
    frame.classList.add('nzs-ov-frame');
    /* NZS-PDPSTARS-0820 (Blake): the star tag comes OFF the gallery image; the above-fold review
       proof is a drawer-style stars row (stars, rating, (count)) under the title that smooth-scrolls
       to the Judge.me widget. Rating/count are harvested from the server-rendered tag's aria-label,
       then every PDP tag copy is removed — the :has() badge rule then lifts the sale badge up. */
    var tags = [].slice.call(document.querySelectorAll('.nzs-rating-tag--pdp'));
    if(tags.length && !document.querySelector('.nzs-pdpstars')){
      var m = (tags[0].getAttribute('aria-label')||'').match(/Rated ([\d.]+) out of 5 from (\d+)/);
      if(m){
        var ra=parseFloat(m[1]), rn=parseInt(m[2],10);
        var S1='<svg viewBox="0 0 16 16" width="15" height="15"><path fill="currentColor" d="M8 1.4l2 4.1 4.5.6-3.3 3.1.8 4.5L8 11.6l-4 2.1.8-4.5L1.5 6.1 6 5.5z"/></svg>';
        var S5=S1+S1+S1+S1+S1;
        var sec=frame.closest('.shopify-section')||document;
        var h1=sec.querySelector('.x-block-product-title h1')||sec.querySelector('h1');
        if(h1 && ra>0 && rn>0){
          var star=document.createElement('button');
          star.type='button'; star.className='nzs-pdpstars';
          star.setAttribute('aria-label','Rated '+ra.toFixed(1)+' out of 5 from '+rn+' review'+(rn===1?'':'s')+' — jump to reviews');
          star.innerHTML='<span class="nzs-cdr__stars-row" aria-hidden="true" style="color:#d8dde3">'+S5
            +'<span class="nzs-cdr__stars-fill" style="width:'+Math.max(0,Math.min(100,ra/5*100))+'%;color:#f5a623">'+S5+'</span></span>'
            +'<span class="nzs-pdpstars__txt" aria-hidden="true">'+ra.toFixed(1)+' ('+rn+')</span>';
          star.addEventListener('click',function(){
            var r=document.getElementById('judgeme_product_reviews')||document.querySelector('[id*="nzs_judgeme_reviews"]');
            if(r) r.scrollIntoView({behavior:'smooth',block:'start'});
          });
          h1.insertAdjacentElement('afterend', star);
        }
      }
      tags.forEach(function(tg){ tg.remove(); });
    }
    var badgeList = [].slice.call(document.querySelectorAll('.x-badges-container')).filter(function(b){ return frame.contains(b) && b.querySelector('.x-badge-content'); });
    var badges = badgeList[0];
    if(badges && badges.parentNode !== frame){ frame.appendChild(badges); }
    /* NZS-BADGE-DEDUPE-PDP-0830: only the first populated container gets hoisted — any extra
       populated copy (duplicate shell / double-load) must not stay visible at its old offset. */
    badgeList.slice(1).forEach(function(b){ b.style.display = 'none'; });
    /* failsafe: the sale badge can lazy-render after the last relocate pass — one-shot observer hoists
       it the moment its content appears, then disconnects (idempotent; never loops on its own append). */
    if(!hoistOverlays.__obs && !badges && window.MutationObserver){
      hoistOverlays.__obs = new MutationObserver(function(){
        var bl = [].slice.call(document.querySelectorAll('.x-badges-container')).filter(function(x){ return frame.contains(x) && x.querySelector('.x-badge-content'); });
        var b = bl[0];
        if(b){ if(b.parentNode !== frame) frame.appendChild(b); bl.slice(1).forEach(function(x){ x.style.display = 'none'; }); hoistOverlays.__obs.disconnect(); hoistOverlays.__obs = true; }
      });
      hoistOverlays.__obs.observe(frame, {childList:true, subtree:true});
    }
  }

  function render(){
    if (!vsw || !data.length || !current) return;
    var famHasSize = data.some(function(d){return d.s;});
    var famHasFlav = data.some(function(d){return d.f;});
    var flavs = [], fseen = {};
    data.forEach(function(d){ if (famHasSize && d.s !== current.s) return; var k = d.f || d.h; if (fseen[k]) return; fseen[k]=1; flavs.push(d); });
    var sizes = [], sseen = {};
    if (famHasSize){ data.forEach(function(d){ if (famHasFlav && d.f !== current.f) return; var k = d.s || d.h; if (sseen[k]) return; sseen[k]=1; sizes.push(d); }); } else { sizes = [current]; }
    var html = '';
    /* NZS-FLAVSTACK-0820 (Blake, Conscious-Bar pattern): swatches are multi-select cards now —
       tap selects (qty stepper appears), tap again deselects (remembered qty kept), the eye opens
       a quick view. NO navigation on select; the eye's "More details" link is the nav path. */
    if (famHasFlav && flavs.length > 1){
      /* circled "i" (Downloads info.png / Conscious Bar) — black ring + dot + bar = circle-in-circle */
      var eyeSvg='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10.2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="7.3" r="1.5"/><rect x="10.6" y="10.2" width="2.8" height="8" rx="1.4"/></svg>';
      html += '<div class="nzs-vsw__group"><span class="nzs-vsw__label">Flavour <b>'+esc(human(current.f))+'</b></span>'
            + '<div class="nzs-vsw__rail" data-nzs-rail-wrap><div class="nzs-vsw__sws nzs-vsw__sws--cards" data-nzs-flav-rail>';
      flavs.forEach(function(d){
        var nm=esc(human(d.f));
        html += '<div class="nzs-vsw__cell'+(d.c?' is-current':'')+(d.a?'':' is-out')+'" data-cell="'+esc(d.h)+'">'
              +   '<button type="button" class="nzs-vsw__sw'+(d.a?'':' is-soldout')+'" data-nzs-flav="'+esc(d.h)+'" title="'+nm+'" aria-pressed="false"'+((d.a||d.c)?'':' disabled')+'>'
              /* NZS-OOSPDP-0820: the current (PDP) swatch is never `disabled` even when sold out — a disabled
                 <button> swallows the tap so it never reaches the delegated toggle. Keeps the is-soldout diagonal. */
              +     (d.th?'<img src="'+esc(d.th)+'" alt="'+nm+'" loading="lazy" width="64" height="64">':'<span class="nzs-vsw__sw-tx">'+nm+'</span>')
              +   '</button>'
              +   (d.c?'':'<button type="button" class="nzs-vsw__eye" data-nzs-qv="'+esc(d.h)+'" data-u="'+esc(d.u)+'" aria-label="Quick view '+nm+'">'+eyeSvg+'</button>')
              +   '<span class="nzs-vsw__foot">'
              +     '<span class="nzs-vsw__name">'+nm+'</span>'
              +     '<span class="nzs-vsw__qty" data-nzs-qty="'+esc(d.h)+'">'
              +       '<button type="button" class="nzs-vsw__qbtn" data-nzs-q="-1" aria-label="Decrease '+nm+' quantity">&minus;</button>'
              +       '<b class="nzs-vsw__qn" aria-live="polite">1</b>'
              +       '<button type="button" class="nzs-vsw__qbtn" data-nzs-q="1" aria-label="Increase '+nm+' quantity">+</button>'
              +     '</span>'
              +   '</span>'
              + '</div>';
      });
      html += '</div><span class="nzs-vsw__more" data-nzs-rail-more aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></span></div>'
            + '<span class="nzs-vsw__err" data-nzs-vsw-err role="status" hidden></span></div>';
    }
    /* Size selector replaced by the OTHER SIZES cards relocated into the buy box (Blake 2026-06-26) */
    vsw.innerHTML = html; bindHover(); flavInit();
  }

  var IS_TOUCH = (window.matchMedia && !window.matchMedia('(hover:hover)').matches);

  // ---- hover preview card ----
  var card=null, hideT=null;
  function ensureCard(){ if(card) return card; card=document.createElement('div'); card.className='nzs-vsw-card'; document.body.appendChild(card); card.addEventListener('mouseenter',function(){clearTimeout(hideT);}); card.addEventListener('mouseleave',hideCard); return card; }
  function showCard(a,d){ var c=ensureCard(); clearTimeout(hideT);
    c.innerHTML='<a class="nzs-vsw-card__img" href="'+esc(d.u)+'">'+(d.th?'<img src="'+esc(d.th)+'">':'')+'</a><span class="nzs-vsw-card__b"><a class="nzs-vsw-card__t" href="'+esc(d.u)+'">'+esc(d.t)+'</a><span class="nzs-vsw-card__p">'+esc(d.pr)+'</span><span class="nzs-vsw-card__hint">Click on title to view full product info</span><button type="button" class="nzs-vsw-card__atc'+(d.a?'':' is-soldout')+'" data-v="'+d.v+'"'+(d.a?'':' disabled')+'>'+(d.a?'Add to cart':'Sold out')+'</button></span>';
    c.__v=d.v; c.__a=d.a; c.__t=d.t; c.__img=d.img;
    var r=a.getBoundingClientRect();
    c.classList.add('is-in');
    var place=function(){ c.style.left=Math.max(8,Math.min(window.innerWidth-242,r.left+r.width/2-115))+'px'; c.style.top=(r.top+window.scrollY-c.offsetHeight-12)+'px'; };
    place(); requestAnimationFrame(place);
  }
  function hideCard(){ if(card) card.classList.remove('is-in'); }
  function bindHover(){ return; /* hover preview card removed 2026-06-24 — flavour names show under each swatch now */ if(!vsw||IS_TOUCH) return; vsw.querySelectorAll('a[data-h]').forEach(function(a){
      a.addEventListener('mouseenter',function(){ var d=data.filter(function(x){return x.h===a.getAttribute('data-h');})[0]; if(d) showCard(a,d); });
      a.addEventListener('mouseleave',function(){ hideT=setTimeout(function(){ if(!card||!card.matches(':hover')) hideCard(); },140); });
  }); }
  document.addEventListener('click', function(e){ var b=e.target.closest('.nzs-vsw-card__atc'); if(!b||b.disabled||!card) return; e.preventDefault(); addToCart(parseInt(b.getAttribute('data-v'),10)); hideCard(); });

  // ---- AJAX add + open drawer ----
  var pdpAddBusy=false;
  function addToCart(vid){ var item=purchaseState(vid); if(!item||pdpAddBusy) return; pdpAddBusy=true; var add=window.nzsATC?window.nzsATC.add({items:[item]},{handle:activeHandle()}):Promise.reject(new Error('Please try again')); add.then(function(){ pdpAddBusy=false; showVC(); var t=document.getElementById('nzsCartToggle'); if(t) t.click(); },function(err){ pdpAddBusy=false; announceCartError(err.message); if(root.__nzsSatcError) root.__nzsSatcError(err.message); }); }
  function showVC(){ var vc=root.querySelector('[data-nzs-viewcart]'); if(vc) vc.hidden=false; }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-nzs-viewcart]')){ var t=document.getElementById('nzsCartToggle'); if(t){ e.preventDefault(); t.click(); } return; }
    if (e.target.closest('[id^="x-atc-button-"], [name="add"], form[action*="/cart/add"] [type="submit"]')){ setTimeout(showVC, 500); }
  });

  /* NZS-FLAVOUR-RELOAD: DEAD since 2026-08-12 (swatch = navigate) — kept as tombstone
  // intercept main ATC: once a different sibling is selected, add THAT one
  var mainAtc = atcEl();
  if (mainAtc){ mainAtc.addEventListener('click', function(e){
      if (!current || current.h === root.getAttribute('data-current-handle')) return; // original product → theme handles
      e.preventDefault(); e.stopImmediatePropagation();
      if (sel && sel.a) addToCart(sel.v);
  }, true); }
  */

  function satcInit(){
    var satc = root.querySelector('[data-nzs-satc]');
    if(!satc) return;
    var sName=satc.querySelector('[data-satc-name]'), sImg=satc.querySelector('[data-satc-img]'),
        sPrice=satc.querySelector('[data-satc-price]'), sSub=satc.querySelector('[data-satc-sub]'),
        sBtn=satc.querySelector('[data-satc-btn]'), sLabel=satc.querySelector('[data-satc-label]'),
        sView=satc.querySelector('[data-satc-view]');
    if(!sBtn) return;
    document.body.appendChild(satc); /* escape the hidden pdpx root so position:fixed renders */
    function liveVid(){ var f=document.querySelector('form[action*="/cart/add"] [name="id"]'); if(f&&f.value) return parseInt(f.value,10); if(sel&&sel.v) return sel.v; return parseInt(sBtn.getAttribute('data-vid')||'0',10); }
    function nameFlav(t){ var p=String(t||'').split(' - '); return {name:p[0], flav:p.length>1?p[p.length-1]:''}; }
    var errorTimer=null;
    function resetAdded(){ clearTimeout(errorTimer); sBtn.classList.remove('is-added','is-error'); sBtn.removeAttribute('title'); if(sView) sView.hidden=true; if(sLabel && !sBtn.disabled) sLabel.textContent='Add to cart'; }
    function markAdded(){ resetAdded(); sBtn.classList.add('is-added'); if(sLabel) sLabel.textContent='Added'; if(sView) sView.hidden=false; }
    function markFailed(message){ message=message||"Couldn't add to cart"; sBtn.classList.remove('is-loading','is-added'); sBtn.classList.add('is-error'); if(sLabel) sLabel.textContent=message; sBtn.title=message; announceCartError(message); clearTimeout(errorTimer); errorTimer=setTimeout(resetAdded,2500); }
    root.__nzsSatcError=markFailed;
    function bumpDot(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ var dt=document.getElementById('nzsCartDot'); if(dt){ dt.textContent=c.item_count; dt.style.display='inline-flex'; } }).catch(function(){}); }
    function updateSatc(d){ if(!d) return; var nf=nameFlav(d.t); if(sName&&nf.name) sName.textContent=nf.name; if(sImg&&d.img){ sImg.removeAttribute('srcset'); sImg.src=d.img; } if(sPrice&&d.pr) sPrice.textContent=d.pr; var sWas=satc.querySelector('[data-satc-was]'); if(sWas){ if(d.cp){ sWas.textContent=d.cp; sWas.hidden=false; } else { sWas.hidden=true; } } var fl=nf.flav||human(d.f||''); var sv=d.sv?(d.sv+(String(d.sv)==='1'?' serve':' serves')):''; if(sSub) sSub.textContent=(fl&&sv)?(fl+' \u00b7 '+sv):(fl||sv||''); var ok=d.a!==false; sBtn.disabled=!ok; sBtn.setAttribute('data-vid', d.v||''); resetAdded(); if(!ok && sLabel) sLabel.textContent='Sold out'; }
    root.__nzsUpdateSatc = updateSatc;
    sBtn.addEventListener('click', function(e){ e.preventDefault(); var item=purchaseState(liveVid()); if(!item||sBtn.disabled||sBtn.classList.contains('is-loading')) return; resetAdded(); sBtn.classList.add('is-loading'); var add=window.nzsATC?window.nzsATC.add({items:[item]},{handle:activeHandle()}):Promise.reject(new Error('Please try again')); add.then(function(){ sBtn.classList.remove('is-loading'); markAdded(); bumpDot(); },function(err){ markFailed(err.message); }); });
    if(sView) sView.addEventListener('click', function(e){ e.preventDefault(); var t=document.getElementById('nzsCartToggle'); if(t) t.click(); });
    document.addEventListener('change', function(e){ var f=e.target&&e.target.closest?e.target.closest('form[action*="/cart/add"]'):null; if(!f) return; setTimeout(function(){ var pe=priceEl(); if(pe&&sPrice) sPrice.textContent=pe.textContent.trim(); sBtn.setAttribute('data-vid', liveVid()); resetAdded(); }, 80); });
    var _atc=atcEl(); var sentinel = _atc ? (_atc.closest('.shopify-section') || _atc) : null;
    /* show ONLY after the product-info section scrolls above the viewport AND hide again once the footer/bottom is in view */
    function nzsAtBottom(){ var f=document.querySelector('.shopify-section-group-footer-group')||document.querySelector('footer'); if(f){ var r=f.getBoundingClientRect(); if(r.height>2) return r.top < (window.innerHeight - 90); } return (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 240); }
    satc.hidden=false;
    function nzsSatcVis(){ var past = sentinel ? (sentinel.getBoundingClientRect().bottom <= 0) : (window.scrollY > window.innerHeight); var show=past&&!nzsAtBottom(); satc.setAttribute('aria-hidden',show?'false':'true'); satc.classList.toggle('is-on',show); }
    window.addEventListener('scroll', nzsSatcVis, {passive:true}); window.addEventListener('resize', nzsSatcVis, {passive:true}); nzsSatcVis();
  }

  /* NZS-VSW-CARRY writer removed 2026-08-20: swatches no longer navigate (multi-select cards).
     The restore path in bindSubs stays — it is a harmless sessionStorage read. */

  /* ==================== NZS-FLAVSTACK-0820 — multi-flavour selection engine ====================
     State: st[handle] = {on:bool, q:int}. Remembered quantities survive deselection (in st) and
     page navs (sessionStorage nzsQtyMem:<family>, quantities only — never availability, never
     selection). The CURRENT product's qty is mastered by the theme's own quantity input; its card
     stepper reads/writes that input, so subscriptions, deal pricing and paintAtc all stay in sync.
     ponytail: plain object + one delegated click listener; no framework, no re-render on change. */
  var st = {}, famKey = 'nzsQtyMem:' + ((vsw && vsw.getAttribute('data-family')) || 'x');
  function memRead(){ try{ return JSON.parse(sessionStorage.getItem(famKey)||'{}')||{}; }catch(_){ return {}; } }
  function memWrite(){ try{ var m={}; data.forEach(function(d){ if(st[d.h] && st[d.h].q>1) m[d.h]=st[d.h].q; }); sessionStorage.setItem(famKey, JSON.stringify(m)); }catch(_){}}
  function formQtyInput(){ return (window.__nzsQtyInput && window.__nzsQtyInput()) || (mainProductForm()||document).querySelector('input[name="quantity"]'); }
  function formQty(){ var i=formQtyInput(), v=i?parseInt(i.value,10):1; return (!v||v<1)?1:v; }
  function cellOf(h){ return vsw ? vsw.querySelector('[data-cell="'+h+'"]') : null; }
  function paintCell(h){
    var c=cellOf(h), s=st[h]; if(!c||!s) return;
    c.classList.toggle('is-sel', !!s.on);
    var b=c.querySelector('[data-nzs-flav]'); if(b) b.setAttribute('aria-pressed', s.on?'true':'false');
    var qn=c.querySelector('.nzs-vsw__qn'); if(qn) qn.textContent = (h===current.h) ? formQty() : (s.q||1);
  }
  function flavInit(){
    if(!vsw || !current) return;
    var mem = memRead();
    data.forEach(function(d){
      if(!cellOf(d.h)) return;
      st[d.h] = { on: !!d.c, q: Math.max(1, parseInt(mem[d.h],10)||1) };
      paintCell(d.h);
    });
    railCheck();
    var rail = vsw.querySelector('[data-nzs-flav-rail]');
    if(rail && !rail.__nzsRail){ rail.__nzsRail=true; rail.addEventListener('scroll', railCheck, {passive:true}); window.addEventListener('resize', railCheck, {passive:true}); }
    /* keep the current card's qty display in step with the theme stepper */
    document.addEventListener('input', function(e){
      if(e.target && e.target.name==='quantity') paintCell(current.h);
    });
    pushFlavTotals();
  }
  function railCheck(){
    var wrap = vsw && vsw.querySelector('[data-nzs-rail-wrap]');
    var rail = wrap && wrap.querySelector('[data-nzs-flav-rail]');
    if(!rail) return;
    var more = (rail.scrollWidth - rail.clientWidth - rail.scrollLeft) > 6;
    if(wrap.__nzsMore !== more){ wrap.__nzsMore = more; wrap.classList.toggle('has-more', more); }
  }
  /* NZS-FLAVPRICE-0820: publish the selected-extras total so paintAtc (below) can show an
     adaptive ATC price. cents/was parsed from the server-rendered money strings in the vsw rows. */
  function centsOf(s){ var n=parseFloat(String(s||'').replace(/[^0-9.]/g,'')); return isFinite(n)?Math.round(n*100):0; }
  /* NZS-OOSPDP-0820: on a sold-out PDP the native ATC ships server-rendered as disabled/"Sold out".
     When the shopper selects an in-stock sibling flavour, transform it into a live "Add to cart"
     (the extras intercept below fulfils it); revert to "Sold out" when nothing addable is selected.
     Only the leading label text node is swapped, so paintAtc's price span is left untouched. */
  function soldOutPdp(){ return !!(current && current.a === false); }
  function atcMainBtns(){ return [].slice.call(document.querySelectorAll('[id^="x-atc-button-"]:not([id*="sticky"]):not([id*="quick-view"])')); }
  function setAtcLabel(btn, txt){ var t=btn.querySelector('.x-atc-text'); if(!t) return; for(var n=t.firstChild;n;n=n.nextSibling){ if(n.nodeType===3 && n.textContent.trim()){ n.textContent=txt+'\n '; return; } } }
  /* ponytail: the store's in-stock delivery line is a fixed message; a sold-out PDP never renders one,
     so morphing into the full in-stock CTA (SS2) means writing it. One string, edit here if it changes. */
  var NZS_INSTOCK_SUB = 'In Stock: Arrives in 1-2 Days';
  function morphSub(btn, on){
    var sub = btn.querySelector('[data-nzs-sub]');
    if(on){ if(!sub){ sub=document.createElement('span'); sub.className='nzs-atc-sub'; sub.setAttribute('data-nzs-sub',''); var lbl=btn.querySelector('.flex.justify-center')||btn.querySelector('.x-atc-text'); if(lbl&&lbl.parentNode===btn) lbl.insertAdjacentElement('afterend',sub); else btn.appendChild(sub); } sub.textContent=NZS_INSTOCK_SUB; }
    else if(sub){ sub.remove(); }   /* only ever removes the one WE injected */
  }
  /* the sold-out ATC ships disabled + ghost/outline. When an in-stock sibling is picked, morph it into
     the full solid-blue in-stock CTA of SS2: solid fill (.nzs-atc-morph), "Add to cart" + price, sub-line. */
  function syncSoldOutAtc(){
    if(!soldOutPdp()) return;
    var live = selectedExtras().length > 0;
    atcMainBtns().forEach(function(b){
      if(live){ b.disabled=false; b.removeAttribute('disabled'); b.classList.add('nzs-atc-morph'); setAtcLabel(b,'Add to cart'); morphSub(b,true); }
      else { b.disabled=true; b.setAttribute('disabled',''); b.classList.remove('nzs-atc-morph'); setAtcLabel(b,'Sold out'); morphSub(b,false); }
    });
  }
  function pushFlavTotals(){
    var cents=0, was=0;
    data.forEach(function(d){
      if(d.c || !st[d.h] || !st[d.h].on || !d.a) return;
      var q=st[d.h].q||1, p=centsOf(d.pr), w=centsOf(d.cp)||p;
      cents+=p*q; was+=w*q;
    });
    var curOn = st[current.h] ? st[current.h].on !== false : true;
    if(!cents && !curOn) curOn=true; /* nothing selected -> ATC falls back to the current flavour */
    /* sold-out current is unbuyable: with extras picked, price the extras only; with none, keep the server price */
    if(current.a===false) curOn = (cents===0);
    window.__nzsFlavExtra={on:curOn, cents:cents, was:was};
    if(window.__nzsPaintAtc) window.__nzsPaintAtc(window.__nzsIsSub);
    syncSoldOutAtc();
  }
  function vswErr(msg){
    var el = vsw && vsw.querySelector('[data-nzs-vsw-err]'); if(!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(el.__t); el.__t = setTimeout(function(){ el.hidden = true; }, 2600);
    announceCartError(msg);
  }
  if(vsw) vsw.addEventListener('click', function(e){
    var qb = e.target.closest('[data-nzs-q]');
    if(qb){
      var qh = qb.closest('[data-nzs-qty]').getAttribute('data-nzs-qty'), s = st[qh]; if(!s) return;
      var delta = parseInt(qb.getAttribute('data-nzs-q'),10)||0;
      if(qh === current.h){
        var qi = formQtyInput(); if(!qi) return;
        var nv = formQty() + delta;
        if(nv < 1){ s.on = false; paintCell(qh); pushFlavTotals(); return; }  /* minus at 1 = deselect, form untouched */
        qi.value = nv; qi.dispatchEvent(new Event('input',{bubbles:true})); qi.dispatchEvent(new Event('change',{bubbles:true}));
        paintCell(qh);
        /* direct repaint: wireQty never arms on no-subscription PDPs (bindSubs early-returns) */
        if(window.__nzsPaintAtc) window.__nzsPaintAtc(window.__nzsIsSub);
        return;
      }
      var q = (s.q||1) + delta;
      if(q < 1){ s.on = false; paintCell(qh); pushFlavTotals(); return; }     /* remembered q stays in st + storage */
      s.q = Math.min(99, q); memWrite(); paintCell(qh); pushFlavTotals();
      return;
    }
    if(e.target.closest('[data-nzs-qv]')) return;           /* eye handled by the quick-view block */
    /* whole card toggles (Conscious Bar pattern) — resolve through the cell's swatch button */
    var cell = e.target.closest('.nzs-vsw__cell');
    var sw = cell && cell.querySelector('[data-nzs-flav]');
    /* NZS-OOSPDP-0820: the current (PDP) card stays toggleable even when sold out so a shopper can
       clear the pre-selected out-of-stock flavour; sold-out siblings remain non-selectable. */
    if(sw && (!sw.disabled || cell.classList.contains('is-current'))){
      var h = sw.getAttribute('data-nzs-flav'), sSt = st[h]; if(!sSt) return;
      sSt.on = !sSt.on;                                      /* re-select restores the remembered q */
      paintCell(h); pushFlavTotals();
    }
  });

  /* ---- main ATC: extras ride along, current stays native ----
     current ON  + extras   -> native click proceeds untouched (subs/deals/analytics/loading all
                               theme-owned) and the extra flavours go up as ONE nzsATC batch add.
     current OFF + extras   -> intercept: batch-add only the extras.
     nothing selected       -> fall through to native: 1x the flavour PDP they are on (Blake 0820). */
  var extrasBusy = false;
  function selectedExtras(){
    return data.filter(function(d){ return !d.c && st[d.h] && st[d.h].on && d.a && d.v; })
               .map(function(d){ return { id: d.v, quantity: (st[d.h].q||1) }; });
  }
  document.addEventListener('click', function(e){
    if(!current || !vsw || !st[current.h]) return;
    var btn = e.target.closest('[id^="x-atc-button-"]:not([id*="sticky"]):not([id*="quick-view"])');
    if(!btn) return;
    var extras = selectedExtras();
    var curOn = st[current.h].on;
    if(!extras.length) return;                               /* native path: adds the current PDP flavour */
    if(extrasBusy){ e.preventDefault(); e.stopImmediatePropagation(); return; }
    extrasBusy = true;
    var intercepted = !curOn || (current && current.a===false); /* sold-out PDP: never fall to native (variant unbuyable) */
    if(intercepted){
      e.preventDefault(); e.stopImmediatePropagation();
      btn.classList.add('nzs-vsw-busy');
    }
    var add = window.nzsATC ? window.nzsATC.add({items:extras}) : Promise.reject(new Error('Please try again'));
    add.then(function(){
      extrasBusy = false; btn.classList.remove('nzs-vsw-busy');
      showVC();
      if(intercepted){ var t=document.getElementById('nzsCartToggle'); if(t) t.click(); }
    }, function(err){
      extrasBusy = false; btn.classList.remove('nzs-vsw-busy');
      vswErr((err && err.message) || "Couldn't add to cart");
    });
  }, true);

  /* ---- quick view (eye): lazy ?view=nzs-qv fragment, cached per handle ---- */
  var qvCache = {}, qvEl = null, qvBody = null, qvCtl = null;
  function qvBuild(){
    if(qvEl) return;
    qvEl = document.createElement('div');
    qvEl.className = 'nzs-qv';
    qvEl.innerHTML = '<div class="nzs-qv__bd" data-nzs-qv-bd></div>'
      + '<div class="nzs-qv__panel" data-nzs-overlay-keep>'
      +   '<button type="button" class="nzs-qv__x" data-nzs-qv-x aria-label="Close quick view"><svg viewBox="0 0 40 40" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M10 30L30 10M10 10L30 30"/></svg></button>'
      +   '<div class="nzs-qv__body" data-nzs-qv-body></div>'
      + '</div>';
    document.body.appendChild(qvEl);
    qvBody = qvEl.querySelector('[data-nzs-qv-body]');
    var panel = qvEl.querySelector('.nzs-qv__panel');
    if(window.nzsOverlay && window.nzsOverlay.enhance){
      /* forced reflow, not rAF: rAF starves in occluded/background windows (QA-FIRSTOPEN pattern) */
      qvCtl = window.nzsOverlay.enhance({ root: panel, key: 'nzs-qv', label: 'Quick view',
        onOpen: function(){ qvEl.classList.add('is-open'); void qvEl.offsetWidth; qvEl.classList.add('is-in'); },
        onClose: function(){ qvEl.classList.remove('is-in'); setTimeout(function(){ qvEl.classList.remove('is-open'); }, 240); } });
    } else {
      /* ponytail: nzs-overlay.js loads with the header on every page; this fallback only loses the focus trap */
      qvCtl = { open: function(){ qvEl.classList.add('is-open'); void qvEl.offsetWidth; qvEl.classList.add('is-in'); },
                close: function(){ qvEl.classList.remove('is-in'); setTimeout(function(){ qvEl.classList.remove('is-open'); }, 240); } };
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && qvEl.classList.contains('is-open')) qvCtl.close(); });
    }
    qvEl.querySelector('[data-nzs-qv-bd]').addEventListener('click', function(){ qvCtl.close(); });
    qvEl.querySelector('[data-nzs-qv-x]').addEventListener('click', function(){ qvCtl.close(); });
    /* More details: close the quick view FIRST, then navigate so the page loader runs on a clean view */
    qvBody.addEventListener('click', function(e){
      var more = e.target.closest('.nzs-qv__more');
      if(more){
        e.preventDefault();
        var u = more.getAttribute('href');
        qvCtl.close();
        setTimeout(function(){ window.location.href = u; }, 260);
        return;
      }
      var th = e.target.closest('[data-nzs-qv-thumb]'); if(!th) return;
      var main = qvBody.querySelector('[data-nzs-qv-main]'); if(!main) return;
      main.src = th.getAttribute('data-src');
      qvBody.querySelectorAll('[data-nzs-qv-thumb]').forEach(function(t){ t.classList.toggle('is-on', t===th); });
    });
  }
  function qvOpen(handle, url, trigger){
    qvBuild();
    if(qvCache[handle]){ qvBody.innerHTML = qvCache[handle]; qvCtl.open({trigger:trigger}); return; }
    qvBody.innerHTML = '<div class="nzs-qv__load" aria-busy="true"></div>';
    qvCtl.open({trigger:trigger});
    fetch('/products/' + encodeURIComponent(handle) + '?view=nzs-qv', { credentials:'same-origin' })
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(txt){
        if(txt.indexOf('data-nzs-qv-frag') === -1) throw 0;
        qvCache[handle] = txt;
        if(qvEl.classList.contains('is-open')) qvBody.innerHTML = txt;
      })
      .catch(function(){ qvCtl.close(); window.location.href = url; }); /* graceful: fall back to the PDP */
  }
  document.addEventListener('click', function(e){
    var eye = e.target.closest('[data-nzs-qv]'); if(!eye) return;
    e.preventDefault();
    qvOpen(eye.getAttribute('data-nzs-qv'), eye.getAttribute('data-u'), eye);
  });
  /* eager flavour-page prefetch loop removed 2026-08-12: theme.liquid already ships Speculation Rules prefetching /products/* on hover — a second eager document-prefetch loop double-fetches. */
  function init(){ relocate(); render(); setTimeout(relocate, 800); setTimeout(relocate, 2500); window.addEventListener('load', relocate); if(window.__nzsFeatures) window.__nzsFeatures(); try{satcInit();}catch(e){} }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
/* NZS-SPD2-0906-P3: the section's four remaining inline blocks, appended in document order.
   They run here (blocking, at the old tag position) against the same DOM they always saw -- there is no
   markup between that tag and where they used to sit. Liquid values come from window.NZSPDPX. */
(function(){
  if(window.__nzsFeatInit) return; window.__nzsFeatInit=true;
  function priceEl(){ var els=[].slice.call(document.querySelectorAll('p.price')).filter(function(e){ return !e.closest('.x-atc-text,[id^="x-atc-button-"],.x-block-buy-buttons,.sticky_add_to_cart'); }); for(var i=0;i<els.length;i++){ if(els[i].offsetParent!==null) return els[i]; } return els[0]||null; }
  var X = window.NZSPDPX || {};   /* NZS-SPD2-0906-P3: Liquid values hoisted into the inline config above the asset tag */
  var NZS_SUB_PRICE = X.subPrice;
  var NZS_SUB_PCT = X.subPct;   /* PDP subscribe discount %, for the per-serve sub figure */
  var NZS_CUR_PRICE = X.curPrice;
  var NZS_BASE_PRICE = X.basePrice;
  var NZS_CUR_CENTS = X.curCents;
  var NZS_SUB_CENTS = X.subCents;
  var NZS_BASE_CENTS = X.baseCents;
  var nzsKach = {widget:null, note:null, dealUnits:1, dealPriceCents:null, dealWasCents:null};
  function nzsFmt(c){var s=(c/100).toFixed(2).split('.');return '$'+s[0].replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+s[1];}
  function nzsQtyInput(){
    var els=[].slice.call(document.querySelectorAll('input[name="quantity"]'));
    for(var i=0;i<els.length;i++){ if(els[i].offsetParent!==null) return els[i]; }
    return els[0]||null;
  }
  window.__nzsQtyInput=nzsQtyInput;   /* NZS-QTY-CARRY-R3: the swatch-carry writer (block above) resolves the qty input through this */
  function nzsQty(){
    var input=nzsQtyInput();
    var v=input?parseInt(input.value,10):NaN;
    if(!v||v<1) v=1;
    return v;
  }
  var nzsAtcPainting = false;
  /* full discount on the ATC button(s): <s>base</s> current (or subscribe) price */
  function paintAtc(isSub){
    window.__nzsIsSub = !!isSub; nzsAtcPainting = true;
    var qty = nzsQty();
    /* NZS-FLAVPRICE-0820: fold in the selected extra flavours (published by the selector engine) */
    var fx = window.__nzsFlavExtra || {on:true, cents:0, was:0};
    var cur, was;
    if (!isSub && nzsKach.dealUnits > 1 && nzsKach.dealPriceCents != null){
      /* bar price is already the DEAL TOTAL (probed live) — no qty multiply here */
      var dCur = nzsKach.dealPriceCents + fx.cents;
      var dWas = (nzsKach.dealWasCents || nzsKach.dealPriceCents) + fx.was;
      cur = nzsFmt(dCur);
      was = dWas > dCur ? nzsFmt(dWas) : '';
    } else {
      var baseCur = (isSub ? NZS_SUB_CENTS : NZS_CUR_CENTS) * qty;
      var baseWas = (NZS_BASE_CENTS > 0 ? NZS_BASE_CENTS * qty : baseCur);
      if (fx.on === false){ baseCur = 0; baseWas = 0; }
      var curT = baseCur + fx.cents, wasT = baseWas + fx.was;
      cur = nzsFmt(curT);
      was = wasT > curT ? nzsFmt(wasT) : '';
    }
    var html = (was ? '<s class="nzs-atc-was">' + was + '</s> ' : '') + '<span>' + cur + '</span>';
    [].slice.call(document.querySelectorAll('.x-atc-text p.price')).forEach(function(p){
      p.innerHTML = html;
      p.__nzsLast = p.innerHTML;
      if (!p.__nzsObs && window.MutationObserver){
        p.__nzsObs = new MutationObserver(function(){
          if (nzsAtcPainting) return;
          if (p.innerHTML === p.__nzsLast) return;
          /* circuit breaker: >8 observer-triggered repaints inside 1s = something is fighting us — stop */
          var now = Date.now();
          if (!p.__nzsFlipT || now - p.__nzsFlipT > 1000){ p.__nzsFlipT = now; p.__nzsFlipN = 0; }
          p.__nzsFlipN++;
          if (p.__nzsFlipN > 8){ p.__nzsObs.disconnect(); return; }
          paintAtc(window.__nzsIsSub);
        });
        p.__nzsObs.observe(p, {childList:true, subtree:true, characterData:true});
      }
    });
    nzsAtcPainting = false;
  }
  window.__nzsPaintAtc = paintAtc;   /* NZS-FLAVPRICE-0820: the selector engine repaints on selection changes */
  function servings(t,sv){ if(sv){return sv;} var rt=document.querySelector('[data-nzs-pdpx]'); var ds=rt?parseInt(rt.getAttribute('data-servings')||'0',10):0; if(ds){return ds;} var s=t||''; if(!s){ var h=document.querySelector('[id^="product_name"]')||document.querySelector('h1'); s=h?h.textContent:document.title; } var m=String(s).match(/(\d+)\s*serv/i); return m?parseInt(m[1],10):0; }

  function perServe(title,sv,priceStr){ /* NZS-PERSERVE-PRICESRC + NZS-PERSERVE-SUBMODE: clean single price string (only p.price is in the ATC button); tracks the selected one-time/subscribe mode */
    var el=document.querySelector('[data-nzs-perserve]'); if(!el) return;
    if(priceStr){ perServe._base=priceStr; }   /* remember the current flavour's ONE-TIME price so a mode toggle can recompute */
    var serv=servings(title,sv);
    if(!serv||serv<2){ el.hidden=true; return; }
    var src=perServe._base||(typeof NZS_CUR_PRICE!=='undefined'?NZS_CUR_PRICE:'');
    if(!src){ var pe=priceEl()||document.querySelector('p.price'); if(pe) src=pe.textContent; }
    var num=parseFloat(String(src).replace(/[^0-9.,]/g,'').replace(/,/g,''));
    if(!num||!isFinite(num)){ el.hidden=true; return; }
    var pct=(typeof NZS_SUB_PCT!=='undefined')?NZS_SUB_PCT:0;   /* subscribe = one-time − pct%, matching the ATC/subscribe price */
    if(window.__nzsIsSub && pct>0){ num=num*(100-pct)/100; }
    el.textContent='$'+(num/serv).toFixed(2)+' per serve · '+serv+' servings';
    el.hidden=false;
  }
  window.__nzsPerServe=perServe;

  function bindSubs(){
    var box=document.querySelector('[data-nzs-subs]'); if(!box) return;
    var form=document.querySelector('form[data-type="add-to-cart-form"]')||document.querySelector('form[action*="/cart/add"]');
    var NZS_ATC_FORMS='form[data-type="add-to-cart-form"]';
    var NZS_ROT_TXT='Auto-ship a different flavour each time for '+X.title;
    var plans=[]; try{ plans=JSON.parse(box.querySelector('[data-nzs-subplans]').textContent)||[]; }catch(e){}
    plans.sort(function(a,b){ return a.w-b.w; });
    var freq=box.querySelector('[data-nzs-subfreq]'),
        range=box.querySelector('[data-nzs-subfreq-range]'),
        valEl=box.querySelector('[data-nzs-subfreq-val]'),
        minEl=box.querySelector('[data-nzs-subfreq-min]'),
        maxEl=box.querySelector('[data-nzs-subfreq-max]');
    var rot=box.querySelector('[data-nzs-subrot]'), rotCb=box.querySelector('[data-nzs-subrot-cb]');
    var multiFlav=false; try{ var _vsw=JSON.parse((document.querySelector('[data-nzs-vsw-data]')||{}).textContent||'[]'); var _fl={}; _vsw.forEach(function(d){ if(d&&d.f) _fl[d.f]=1; }); multiFlav=Object.keys(_fl).length>1; }catch(e){}
    function setRot(on){ document.querySelectorAll(NZS_ATC_FORMS).forEach(function(f){ var p=f.querySelector('input[name="properties[Flavour rotation]"]');
      if(on){ if(!p){ p=document.createElement('input'); p.type='hidden'; p.name='properties[Flavour rotation]'; f.appendChild(p); } p.value=NZS_ROT_TXT; }
      else if(p){ p.parentNode.removeChild(p); } }); }
    if(range && plans.length){
      range.min=0; range.max=plans.length-1;
      /* Default the cadence to how long the product lasts: 1 serve/day => 7 serves/week.
         Pick the largest available plan week <= weeksSupply; fall back to nearest-to-6 then smallest. */
      var def=-1, svN=(typeof servings==='function'?servings():0);
      if(svN>0){ var wkSup=Math.floor(svN/7); for(var i=0;i<plans.length;i++){ if(plans[i].w<=wkSup) def=i; } }
      if(def<0){ for(var j=0;j<plans.length;j++){ if(plans[j].w>=6){ def=j; break; } } }
      if(def<0) def=0;
      range.value=def;
      updGlow();
      if(minEl) minEl.textContent=plans[0].w+' wks';
      if(maxEl) maxEl.textContent=plans[plans.length-1].w+' wks';
    }
    function idx(){ return range?Math.max(0,Math.min(plans.length-1,parseInt(range.value,10)||0)):0; }
    function curWeeks(){ return plans[idx()]?plans[idx()].w:0; }
    function curId(){ return plans[idx()]?plans[idx()].id:''; }
    function setSP(val){ document.querySelectorAll(NZS_ATC_FORMS).forEach(function(f){ var sp=f.querySelector('input[name="selling_plan"]');
      if(val){ if(!sp){ sp=document.createElement('input'); sp.type='hidden'; sp.name='selling_plan'; f.appendChild(sp); } sp.value=val; }
      else if(sp){ sp.parentNode.removeChild(sp); } }); }
    function updLabel(){ if(valEl) valEl.textContent='Auto-ship every '+curWeeks()+' weeks'; }
    function updGlow(){ if(!range) return; var pct=(range.value-range.min)/((range.max-range.min)||1)*100; range.style.setProperty('--nzs-pos', pct+'%'); }
    function applyMode(){
      var chk=box.querySelector('input[name="nzs_sub"]:checked');
      var isSub=chk && chk.value==='subscribe';
      document.body.classList.toggle('nzs-submode', isSub); /* NZS-SUBMODE: body mode class — CSS drives subscribe-mode UI (Kaching deal collapse etc.) */
      if(freq) freq.hidden=!isSub;
      if(rot){ var showRot=isSub && multiFlav; rot.hidden=!showRot; if(!showRot && rotCb) rotCb.checked=false; }
      setSP(isSub?curId():'');
      setRot(isSub && multiFlav && rotCb && rotCb.checked);
      updLabel();
      paintAtc(isSub);
      if(window.__nzsPerServe) window.__nzsPerServe();   /* recompute per-serve for the selected mode */
    }
    box.addEventListener('change',function(e){
      var r=e.target.closest('input[name="nzs_sub"]'); if(!r) return;
      box.querySelectorAll('.nzs-sub').forEach(function(l){ l.classList.toggle('is-on', l.contains(r)); });
      applyMode();
    });
    if(range){ range.addEventListener('input',function(){ updLabel(); updGlow(); var chk=box.querySelector('input[name="nzs_sub"]:checked'); if(chk&&chk.value==='subscribe') setSP(curId()); }); }
    if(rotCb){ rotCb.addEventListener('change',function(){ setRot(rotCb.checked); }); }

    /* NZS-KACH-ORDER: Kaching Bundles deal-bar integration. The app self-injects <kaching-bundle>
       late/async inside the buy box (an anonymous block div also holding form.form). We DON'T move
       the widget (it isn't a registered custom element and moving app DOM is fragile — probed live);
       instead we insert our exclusion note after it and move OUR subs box after the note, so the
       visual order inside that div is widget -> note -> subs -> form/ATC. When a multi-unit deal is
       selected we force one-time + collapse our subscribe cards (CSS animates), and repaint the ATC
       price off the deal's own displayed total (already the full deal total — no qty multiply).
       Everything degrades to a no-op if Kaching isn't present or its DOM doesn't match. */
    function dealUnitsFor(radioValue){
      try{
        var s=document.querySelector('script.kaching-bundles-deal-block-settings[data-product-id="'+X.pid+'"]')||document.querySelector('script.kaching-bundles-deal-block-settings');
        var cfg=JSON.parse(s.textContent);
        var bars=cfg.dealBars||[];
        var bar=null;
        for(var i=0;i<bars.length;i++){ if(String(bars[i].id)===String(radioValue)){ bar=bars[i]; break; } }
        if(!bar) return 1;
        return bar.quantity||((bar.buyQuantity||0)+(bar.getQuantity||0))||1;
      }catch(e){ return 1; }
    }
    function readDealPrice(radio){
      try{
        var bar=radio.closest('.kaching-bundles__bar')||radio.closest('[class*="kaching-bundles__bar"]')||radio.closest('label')||radio.parentNode;
        function toCents(txt){ if(!txt) return null; var n=parseFloat(String(txt).replace(/[^0-9.]/g,'')); return isFinite(n)?Math.round(n*100):null; }
        var curEl=bar.querySelector('.kaching-bundles__bar-price');
        var wasEl=bar.querySelector('.kaching-bundles__bar-full-price');
        return { cur: toCents(curEl&&curEl.textContent), was: toCents(wasEl&&wasEl.textContent) };
      }catch(e){ return { cur:null, was:null }; }
    }
    var nzsDealGen=0, nzsDealHandling=false;
    function wireDeals(){
      var widget=nzsKach.widget; if(!widget||widget.__nzsWired) return;
      widget.__nzsWired=true;
      function checkedRadio(){ try{ return widget.querySelector('input[name^="kaching-bundles-deal-"]:checked'); }catch(e){ return null; } }
      function handle(radio){
        if(!radio) return;
        var gen=++nzsDealGen;
        nzsDealHandling=true;
        try{
          var units=dealUnitsFor(radio.value);
          var prices=readDealPrice(radio);
          nzsKach.dealUnits=units;
          nzsKach.dealPriceCents=prices.cur;
          nzsKach.dealWasCents=prices.was;
          if(units>1){
            var onetime=box.querySelector('input[name="nzs_sub"][value="onetime"]');
            if(onetime && !onetime.checked){
              onetime.checked=true;
              box.querySelectorAll('.nzs-sub').forEach(function(l){ l.classList.toggle('is-on', l.contains(onetime)); });
            }
            applyMode();
            box.classList.add('nzs-subs--dealhidden');
            if(prices.cur==null){
              /* deferred deal price: bar totals can render after the radio state — poll up to 10x200ms,
                 abandoned if a newer handle() run bumps the generation counter */
              var tries=0;
              var poll=function(){
                if(gen!==nzsDealGen||tries>=10) return;
                tries++;
                setTimeout(function(){
                  if(gen!==nzsDealGen) return;
                  var p2=readDealPrice(radio);
                  if(p2.cur!=null){ nzsKach.dealPriceCents=p2.cur; nzsKach.dealWasCents=p2.was; paintAtc(window.__nzsIsSub); }
                  else poll();
                },200);
              };
              poll();
            }
          } else {
            box.classList.remove('nzs-subs--dealhidden');
            applyMode();
          }
        }catch(e){}
        nzsDealHandling=false;
      }
      widget.addEventListener('change',function(e){
        var r=e.target.closest('input[name^="kaching-bundles-deal-"]'); if(!r) return;
        handle(r);
      });
      /* product-picker freshness: swapping a picked product inside a bar (bxgy picker) changes the
         bar's displayed total WITHOUT firing a deal-radio change event. Watch the widget's text and
         re-read the checked bar's price, debounced; only repaint when the parsed price moved. Kaching
         never writes into the theme ATC button (updateNativePrice:false), so no ping-pong with paintAtc. */
      if(window.MutationObserver){
        var pickT=null;
        var pickObs=new MutationObserver(function(){
          if(nzsDealHandling) return;
          if(pickT) clearTimeout(pickT);
          pickT=setTimeout(function(){
            try{
              if(nzsDealHandling) return;
              var r=checkedRadio(); if(!r) return;
              var p2=readDealPrice(r);
              if(p2.cur!=null && (p2.cur!==nzsKach.dealPriceCents || p2.was!==nzsKach.dealWasCents)){
                nzsKach.dealPriceCents=p2.cur;
                nzsKach.dealWasCents=p2.was;
                if(nzsKach.dealUnits>1) paintAtc(window.__nzsIsSub);
              }
            }catch(e){}
          },150);
        });
        pickObs.observe(widget,{childList:true,characterData:true,subtree:true});
      }
      try{
        var initial=checkedRadio();
        if(initial) handle(initial);
      }catch(e){}
    }
    function nzsAtcBtn(){var els=[].slice.call(document.querySelectorAll('[id^="x-atc-button-"]:not([id*="sticky"])'));for(var i=0;i<els.length;i++){if(els[i].offsetParent!==null&&els[i].getBoundingClientRect().width>0)return els[i];}return els[0]||null;}
    function watchKaching(){
      var btn=nzsAtcBtn();
      var buyWrap=btn&&(btn.closest('.x-block-buy-buttons')||btn.parentNode);
      if(!buyWrap){
        if(!watchKaching.__retried){ watchKaching.__retried=true; setTimeout(watchKaching,2500); }
        return;
      }
      function tryAttach(){
        try{
          var widget=buyWrap.querySelector('kaching-bundle');
          if(!widget||nzsKach.widget) return false;
          /* widget stays where the app put it — note goes after it, OUR subs box after the note */
          var note=document.createElement('p');
          note.className='nzs-kachnote';
          note.textContent='This limited-time deal applies to one-time orders only';
          widget.parentNode.insertBefore(note, widget.nextSibling);
          widget.parentNode.insertBefore(box, note.nextSibling);
          nzsKach.widget=widget;
          nzsKach.note=note;
          wireDeals();
          return true;
        }catch(e){ return false; }
      }
      tryAttach();
      /* observer stays alive: handles late injection, app re-injection (stale widget swap), and a
         later relocate() retry yanking our subs box back out (re-pin it after the note) */
      if(window.MutationObserver){
        var obs=new MutationObserver(function(){
          try{
            if(nzsKach.widget && !nzsKach.widget.isConnected){
              if(nzsKach.note && nzsKach.note.parentNode) nzsKach.note.parentNode.removeChild(nzsKach.note);
              nzsKach.widget=null; nzsKach.note=null;
              nzsKach.dealUnits=1; nzsKach.dealPriceCents=null; nzsKach.dealWasCents=null;
              box.classList.remove('nzs-subs--dealhidden');
              paintAtc(window.__nzsIsSub);
            }
            if(!nzsKach.widget){ tryAttach(); }
            else if(nzsKach.note && nzsKach.note.parentNode && box.previousElementSibling!==nzsKach.note){
              nzsKach.note.parentNode.insertBefore(box, nzsKach.note.nextSibling);
            }
          }catch(e){}
        });
        obs.observe(buyWrap,{childList:true,subtree:true});
      }
    }
    function wireQty(){
      try{
        var input=nzsQtyInput();
        if(!input){
          if(!wireQty.__retried){ wireQty.__retried=true; setTimeout(wireQty,2500); }
          return;
        }
        if(input.__nzsQtyWired) return;
        input.__nzsQtyWired=true;
        ['input','change'].forEach(function(evt){ input.addEventListener(evt,function(){ paintAtc(window.__nzsIsSub); }); });
      }catch(e){}
    }
    watchKaching();
    wireQty();

    /* NZS-VSW-CARRY: re-apply qty + subscribe carried over a flavour-swatch nav (applyMode below does the setSP + ATC paint) */
    try{
      var carry=JSON.parse(sessionStorage.getItem('nzsVswCarry')||'null');
      if(carry && carry.t){ sessionStorage.removeItem('nzsVswCarry');
        if(Date.now()-carry.t < 120000){
          /* cq>1 on purpose: 1 is the default, so there is nothing to restore. The dispatched 'input'
             is what makes wireQty repaint the ATC price and lets the theme's own qty state resync. */
          var cq=parseInt(carry.qty,10), qi=nzsQtyInput(); if(qi && cq>1){ qi.value=cq; qi.dispatchEvent(new Event('input',{bubbles:true})); }
          var csub=carry.sp?box.querySelector('input[name="nzs_sub"][value="subscribe"]'):null;
          if(csub){
            for(var ci=0;ci<plans.length;ci++){ if(range && String(plans[ci].id)===String(carry.sp)){ range.value=ci; updGlow(); break; } }
            csub.checked=true; box.querySelectorAll('.nzs-sub').forEach(function(l){ l.classList.toggle('is-on', l.contains(csub)); });
          }
        }
      }
    }catch(_){}

    applyMode();
  }

  function bindOffers(){
    var box=document.querySelector('[data-nzs-offers]'); if(!box) return;
    box.addEventListener('click',function(e){
      var b=e.target.closest('.nzs-offer__code'); if(!b) return;
      var code=b.getAttribute('data-code'); try{ navigator.clipboard.writeText(code); }catch(_){}
      var tx=b.querySelector('.nzs-offer__txt'); if(!tx) return;
      var old=tx.textContent; b.classList.add('is-copied'); tx.textContent='Copied';
      setTimeout(function(){ tx.textContent=old; b.classList.remove('is-copied'); },1400);
    });
  }

  function run(){
    if(run.__ran) return; run.__ran=true;
    perServe(); paintAtc(false); bindSubs(); bindOffers(); setTimeout(function(){ paintAtc(window.__nzsIsSub); }, 900);
    var pe=priceEl();
    if(pe && window.MutationObserver){ new MutationObserver(function(){ perServe(); }).observe(pe,{childList:true,characterData:true,subtree:true}); }
  }
  window.__nzsFeatures=run;
  if(document.readyState!=='loading'){ setTimeout(run,0); } else { document.addEventListener('DOMContentLoaded',run); }
})();
(function(){
  if(window.__nzsLbInit) return; window.__nzsLbInit=true;
  var X = window.NZSPDPX || {};   /* NZS-SPD2-0906-P3: chevron svg captured in the inline config */
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  /* NZS-LB-SLIDES-R3 (2026-08-12): the old collector was a document-wide query filtered per slide by
     getBoundingClientRect()>0, which on mobile kept exactly ONE item. media-gallery.liquid ships
     `.transition-fade .x-splide-slide .image-detail{display:none}` and only re-shows :first-child /
     .is-active / .is-next — and the mobile strip is the NATIVE (non-Splide) gallery, so nothing ever
     gets .is-active, leaving slides 2..N measuring 0x0 and dropped. Pick the CONTAINER by breakpoint
     instead of measuring each slide: desktop = the cross-fade stage (children are opacity:0 but laid
     out), mobile = the native strip's .splide__list (laid out horizontally, most off-viewport). Both
     yield items === product media count. Dedupe-by-src still happens in open().
     Mobile stays ARROWLESS on purpose (.nzs-gal-arrow lives in the md-only stage) — it navigates by
     thumb rail + swipe; that is Blake's mobile pattern, so do not "restore" chevrons there. */
  function laidOut(el){ return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function slidesRoot(){
    var stage=document.querySelector('.nzs-stage__inner') || document.querySelector('[id^="stacked-"]');
    if(laidOut(stage)) return stage;
    return document.querySelector('.nzs-native-gallery .splide__list') || document;
  }
  function slides(){ return [].slice.call(slidesRoot().querySelectorAll('[aria-label="zoom-image"]')).filter(function(s){ return !s.closest('[id*="ProductModal"]'); }); }
  function imgOf(s){ return s.querySelector('img.image-detail') || s.querySelector('img'); }
  function hires(img){
    var ss=img.getAttribute('srcset')||'';
    if(ss){ var p=ss.split(',').map(function(x){return x.trim();}); var last=p[p.length-1].split(/\s+/)[0]; if(last) return last; }
    return (img.getAttribute('src')||'').split('?')[0];
  }
  function thumbOf(img){
    var ss=img.getAttribute('srcset')||'';
    if(ss){ var first=ss.split(',')[0].trim().split(/\s+/)[0]; if(first) return first; }
    return (img.getAttribute('src')||'').split('?')[0];
  }
  var lb,lbImg,items=[],cur=0,zoomed=false,closeT=null;
  function build(){
    if(lb) return;
    lb=document.createElement('div'); lb.className='nzs-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true');
    lb.innerHTML='<div class="nzs-lb__bg"></div>'
      +'<button type="button" class="nzs-lb__x" aria-label="Close zoom"><svg viewBox="0 0 40 40" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 30L30 10M10 10L30 30"/></svg></button>'
      +'<div class="nzs-lb__stage">'
        +'<figure class="nzs-lb__fig">'
          +'<div class="nzs-lb__frame"><img class="nzs-lb__img" alt=""></div>'
          +'<button type="button" class="nzs-lb__nav nzs-lb__prev" aria-label="Previous image">'+X.lbChevL+'</button>'
          +'<button type="button" class="nzs-lb__nav nzs-lb__next" aria-label="Next image">'+X.lbChevR+'</button>'
        +'</figure>'
        +'<div class="nzs-gthumbs nzs-lb__thumbs" data-nzs-lb-thumbs role="tablist"><span class="nzs-gthumbs__ink"></span></div>'
      +'</div>';
    document.body.appendChild(lb);
    lbImg=lb.querySelector('.nzs-lb__img');
    lb.querySelector('.nzs-lb__bg').addEventListener('click',close);
    lb.querySelector('.nzs-lb__stage').addEventListener('click',function(e){ if(e.target===this) close(); });
    lb.querySelector('.nzs-lb__x').addEventListener('click',function(e){e.stopPropagation();close();});
    lb.querySelector('.nzs-lb__prev').addEventListener('click',function(e){e.stopPropagation();go(-1);});
    lb.querySelector('.nzs-lb__next').addEventListener('click',function(e){e.stopPropagation();go(1);});
    lbImg.addEventListener('click',function(e){ e.stopPropagation(); if(zoomed){ setZoom(false); } else { setZoom(true); pan(e); } });
    lbImg.addEventListener('mousemove',pan);
    lb.querySelector('[data-nzs-lb-thumbs]').addEventListener('click',function(e){ var b=e.target.closest('.nzs-gthumb'); if(!b) return; e.stopPropagation(); var i=parseInt(b.getAttribute('data-idx'),10); if(!isNaN(i)) show(i); });
    document.addEventListener('keydown',function(e){
      if(!lb.classList.contains('is-open')) return;
      if(e.key==='Escape') close();
      else if(e.key==='ArrowLeft') go(-1);
      else if(e.key==='ArrowRight') go(1);
    });
  }
  function setZoom(on){ zoomed=on; lbImg.classList.toggle('is-zoomed',on); lbImg.style.transform= on?'scale(2.6)':''; if(!on) lbImg.style.transformOrigin='center center'; }
  function pan(e){ if(!zoomed) return; var r=lbImg.getBoundingClientRect(); var x=Math.min(100,Math.max(0,(e.clientX-r.left)/r.width*100)); var y=Math.min(100,Math.max(0,(e.clientY-r.top)/r.height*100)); lbImg.style.transformOrigin=x+'% '+y+'%'; }
  function renderThumbs(){
    var rail=lb.querySelector('[data-nzs-lb-thumbs]'); if(!rail) return;
    var html='';
    items.forEach(function(it,i){ html+='<button type="button" class="nzs-gthumb" data-idx="'+i+'" role="tab"><span class="nzs-gthumb__box"><img src="'+esc(it.thumb)+'" alt="'+esc(it.alt)+'" loading="lazy" decoding="async"></span></button>'; });
    rail.innerHTML=html+'<span class="nzs-gthumbs__ink"></span>';
    rail.hidden=items.length<2;
  }
  function paintThumbs(){
    var rail=lb.querySelector('[data-nzs-lb-thumbs]'); if(!rail) return;
    var btns=rail.querySelectorAll('.nzs-gthumb'), active=btns[cur];
    for(var i=0;i<btns.length;i++){ var on=i===cur; btns[i].classList.toggle('is-on',on); btns[i].setAttribute('aria-selected',on?'true':'false'); }
    var ink=rail.querySelector('.nzs-gthumbs__ink');
    if(ink && active){
      ink.style.left=active.offsetLeft+'px'; ink.style.width=active.offsetWidth+'px';
      /* NZS-LB-INK-R3 (2026-08-12): the rail is built while .nzs-lb is display:none, so a paint that
         lands before the first layout measures 0 and leaves the ink at width:0 (invisible). One
         non-recursive rAF re-measure; the CSS colour/height lives in the shared .nzs-gthumbs__ink. */
      if(!active.offsetWidth){ requestAnimationFrame(function(){ var b=rail.querySelector('.nzs-gthumb.is-on'); if(b){ ink.style.left=b.offsetLeft+'px'; ink.style.width=b.offsetWidth+'px'; } }); }
    }
    if(active && active.scrollIntoView){ try{ active.scrollIntoView({block:'nearest',inline:'nearest'}); }catch(_){} }
  }
  function show(i){
    cur=(i+items.length)%items.length; setZoom(false);
    lbImg.src=items[cur].src; lbImg.alt=items[cur].alt;
    var multi=items.length>1;
    lb.querySelector('.nzs-lb__prev').style.display=multi?'':'none';
    lb.querySelector('.nzs-lb__next').style.display=multi?'':'none';
    paintThumbs();
  }
  function go(d){ show(cur+d); }
  function open(idx){
    build();
    var seen={};
    items=slides().map(function(s){var im=imgOf(s);return im?{src:hires(im),alt:im.getAttribute('alt')||'',thumb:thumbOf(im)}:null;})
      .filter(Boolean).filter(function(it){ if(seen[it.src]) return false; seen[it.src]=1; return true; });
    if(!items.length) return;
    if(closeT){ clearTimeout(closeT); closeT=null; }
    renderThumbs();
    lb.classList.add('is-open'); document.documentElement.classList.add('nzs-lb-open');
    show(Math.max(0,Math.min(idx,items.length-1)));
    requestAnimationFrame(function(){ lb.classList.add('is-in'); paintThumbs(); });
  }
  window.__nzsLbOpen=open;
  function close(){
    if(!lb) return; setZoom(false);
    lb.classList.remove('is-in');
    var done=function(){ lb.classList.remove('is-open'); document.documentElement.classList.remove('nzs-lb-open'); closeT=null; };
    if(closeT) clearTimeout(closeT);
    closeT=setTimeout(done,320);
    lb.addEventListener('transitionend',function h(ev){ if(ev.target===lb && ev.propertyName==='opacity'){ if(closeT){ clearTimeout(closeT); closeT=null; } done(); lb.removeEventListener('transitionend',h); } });
  }
  /* NZS-LB-DRAGGUARD (2026-08-06): this capture-phase hijack runs BEFORE Splide's own
     post-drag click suppressor (bound on the track), so a gallery swipe would END by
     opening the lightbox. Track the last pointerdown; a click that drifted >10px from it
     is the tail of a drag, not a tap -- let it pass untouched. e.detail===0 = keyboard
     activation, which has no pointer coords and must always open. */
  var _lbPd={x:0,y:0};
  document.addEventListener('pointerdown',function(e){ _lbPd.x=e.clientX; _lbPd.y=e.clientY; },true);
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[aria-label="Image zoom"]');
    if(!btn || !btn.closest('[aria-label="zoom-image"]')) return;
    if(e.detail!==0 && (Math.abs(e.clientX-_lbPd.x)>10 || Math.abs(e.clientY-_lbPd.y)>10)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var slide=btn.closest('[aria-label="zoom-image"]');
    var all=slides(); var idx=all.indexOf(slide);
    open(idx<0?0:idx);
  },true);
  /* NZS-LB-SPYGLASS: the restyled spyglass button opens the lightbox at the image the shopper is
     currently viewing. The gallery controller (WS5) writes data-nzs-gal-index onto the active
     stage cell (.nzs-on) on every activate; read it here, default to the first image. */
  document.addEventListener('click',function(e){
    var sg=e.target.closest('[data-nzs-spyglass]'); if(!sg) return;
    e.preventDefault(); e.stopPropagation();
    var host=document.getElementById('product-media-'+(sg.dataset.nzsSpyglass||'')) || sg.parentNode || document;
    var cell=host.querySelector('.nzs-on[data-nzs-gal-index]') || host.querySelector('[data-nzs-gal-index]');
    var idx=cell?parseInt(cell.getAttribute('data-nzs-gal-index')||'0',10):0;
    open(isNaN(idx)?0:idx);
  },false);
})();
(function(){
  var box=document.querySelector('[data-nzs-rtd-offer]');
  if(!box||box.__rtdInit)return; box.__rtdInit=true;
  var coll=box.getAttribute('data-rtd-collection')||'all-rtd';
  var ids=null, idsReady=null;
  function loadIds(){ if(idsReady) return idsReady; idsReady=fetch('/collections/'+coll+'/products.json?limit=250').then(function(r){return r.json();}).then(function(d){ ids={}; (d.products||[]).forEach(function(pp){ids[pp.id]=1;}); }).catch(function(){ ids={}; }); return idsReady; }
  var t1=parseInt(box.getAttribute('data-t1-qty'),10)||0, t2=parseInt(box.getAttribute('data-t2-qty'),10)||0;
  var c1=box.getAttribute('data-t1-code')||'', c2=box.getAttribute('data-t2-code')||'';
  var prog=box.querySelector('[data-nzs-rtd-progress]'), fill=box.querySelector('[data-nzs-rtd-fill]'),
      msg=box.querySelector('[data-nzs-rtd-msg]'), applyBtn=box.querySelector('[data-nzs-rtd-apply]'),
      tiers=[].slice.call(box.querySelectorAll('.nzs-rtd-offer__tier'));
  function bestCode(q){ if(t2&&q>=t2&&c2)return c2; if(t1&&q>=t1&&c1)return c1; if(t2&&c2)return c2; if(t1&&c1)return c1; return ''; }
  function update(q){
    tiers.forEach(function(el){ var need=el.getAttribute('data-tier')==='2'?t2:t1; el.classList.toggle('is-reached', need>0&&q>=need); });
    var target=(t2&&q<t2)?t2:((t1&&q<t1)?t1:(t2||t1));
    if(prog&&msg){
      if(!t1&&!t2){ prog.hidden=true; }
      else{
        prog.hidden=false; var pct=target?Math.min(100,Math.round(q/target*100)):0; if(fill)fill.style.width=pct+'%';
        if(t2&&q>=t2){ msg.innerHTML='<b>Top tier unlocked.</b> The case discount applies at checkout.'; }
        else if(t1&&q>=t1){ var more=(t2||0)-q; msg.innerHTML='<b>'+q+' in cart</b> &mdash; offer unlocked.'+((t2&&more>0)?' Add <b>'+more+'</b> more for the case deal.':''); }
        else if(t1){ var n=t1-q; msg.innerHTML=(q>0?'<b>'+q+' in cart.</b> ':'')+'Add <b>'+n+'</b> more ready-to-drink can'+(n===1?'':'s')+' to unlock the offer.'; }
      }
    }
    if(applyBtn){ var code=bestCode(q); applyBtn.hidden=!code; applyBtn.setAttribute('data-active-code',code); }
  }
  function rtdQty(cart){ var q=0; (cart.items||[]).forEach(function(it){ if(ids&&ids[it.product_id])q+=it.quantity; }); return q; }
  function refresh(){ Promise.all([loadIds(), fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();})]).then(function(a){ update(rtdQty(a[1])); }).catch(function(){ update(0); }); }
  if(applyBtn){ applyBtn.addEventListener('click',function(){ var code=applyBtn.getAttribute('data-active-code'); if(code)window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart'; }); }
  refresh();
  document.addEventListener('click',function(e){ if(e.target.closest('[name="add"],[id^="x-atc-button-"],form[action*="/cart/add"] [type="submit"],.nzs-cdr__qty-btn'))setTimeout(refresh,700); });
  ['nzs:cart:updated','cart:updated','cart:refresh'].forEach(function(ev){document.addEventListener(ev,refresh);});
  // ---- pill ATC on tier selection ----
  var pill=box.querySelector('[data-nzs-rtd-pill]'), pillLab=box.querySelector('[data-nzs-rtd-pill-lab]'), pillAdd=box.querySelector('[data-nzs-rtd-pill-add]'), selQty=0;
  if(pill && pill.parentNode!==document.body){ document.body.appendChild(pill); }
  function variantId(){ var f=document.querySelector('form[action*="/cart/add"] [name="id"]'); return f?parseInt(f.value,10):0; }
  function selectTier(el){ var q=el.getAttribute('data-tier')==='2'?t2:t1; if(!q)return;
    tiers.forEach(function(t){t.classList.toggle('is-selected',t===el);}); selQty=q;
    var deal=(el.querySelector('.nzs-rtd-offer__deal')||{}).textContent||'';
    if(pill&&pillLab){ pillLab.innerHTML='<b>'+q+'</b> &times; this can &mdash; '+deal; pill.hidden=false; if(pillAdd)pillAdd.textContent='Add '+q+' to cart'; } }
  tiers.forEach(function(el){ el.addEventListener('click',function(){selectTier(el);}); el.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();selectTier(el);} }); });
  if(pillAdd){ pillAdd.addEventListener('click',function(){ var vid=variantId(); if(!vid||!selQty)return; pillAdd.disabled=true;
    var pdpx=document.querySelector('[data-nzs-pdpx]');
    var handle=pdpx&&pdpx.getAttribute('data-current-handle')||'';
    var add=window.nzsATC?window.nzsATC.add({items:[{id:vid,quantity:selQty}]},{handle:handle}):Promise.reject(new Error('Please try again'));
    add.then(function(){ pillAdd.disabled=false; pill.hidden=true; tiers.forEach(function(t){t.classList.remove('is-selected');}); var tog=document.getElementById('nzsCartToggle'); if(tog)tog.click(); setTimeout(refresh,600); }).catch(function(err){ var message=err.message||"Couldn't add to cart"; pillAdd.textContent=message; pillAdd.title=message; if(pdpx&&pdpx.__nzsAnnounceCartError)pdpx.__nzsAnnounceCartError(message); setTimeout(function(){ pillAdd.textContent='Add '+selQty+' to cart'; pillAdd.removeAttribute('title'); pillAdd.disabled=false; },2500); }); }); }
})();
/* NZS-RTD-STICKY-JS — flag body.nzs-sticky-on when ANY sticky ATC bar is on screen (custom .nzs-satc OR native .sticky_add_to_cart), so the floating RTD pill hides instead of colliding with it. Scroll-driven; both stickies appear on scroll. */
(function(){
  if(window.__nzsRtdSticky) return; window.__nzsRtdSticky=true;
  function vis(el){ if(!el) return false; var cs=getComputedStyle(el); if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity||'1')<0.05) return false; var r=el.getBoundingClientRect(); return r.height>2 && r.bottom>4 && r.top<(window.innerHeight-2); }
  function check(){ var s=document.querySelector('.nzs-satc.is-on'); var n=document.querySelector('[id^="sticky-add-to-cart-"], .sticky_add_to_cart'); document.body.classList.toggle('nzs-sticky-on', !!((s&&vis(s))||vis(n))); }
  ['scroll','resize','orientationchange'].forEach(function(e){ window.addEventListener(e, check, {passive:true}); });
  document.addEventListener('shopify:section:load', check);
  if(document.readyState!=='loading') check(); else document.addEventListener('DOMContentLoaded', check);
})();
